export const DOCUMENT_TYPE_NAME = {
  APPLICATION_SUMMARY: 'Application Summary',
} as const

export const SPECIAL_DOCUMENT_LABELS = {
  ACTION_REQUIRED: 'Action Required',
  AWAITING_CLIENT: 'Awaiting client',
} as const

export const APPLICATION_STATUS = {
  ALL: 'All',
  PREPARING: 'Preparing',
  APPROVED: 'Approved',
  VERIFYING: 'Verifying',
  COMPLETED: 'Completed',
  APOSTILLE: 'Apostille',
  MAILING: 'Mailing',
  // Legacy status constants for backwards compatibility
  CREATED: 'Created',
  IN_PROGRESS: 'InProgress',
  SUBMITTED: 'Submitted',
} as const
export type TApplicationStatusKey = keyof typeof APPLICATION_STATUS
export type TApplicationStatusType = (typeof APPLICATION_STATUS)[TApplicationStatusKey]

export const APPLICATION_SYNC_STATUS = {
  NOT_SYNCED: 'NotSynced',
  ERROR: 'Error',
  SYNCED: 'Synced',
  SYNCING: 'Syncing',
} as const
export type TApplicationSyncStatusKey = keyof typeof APPLICATION_SYNC_STATUS
export type TApplicationSyncStatusType = (typeof APPLICATION_SYNC_STATUS)[TApplicationSyncStatusKey]

export const CLIENT_DOCUMENT_STATUS = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  UPLOAD_REQUIRED: 'UploadRequired',
  WAITING_APPROVAL: 'WaitingApproval',
  IN_PROGRESS: 'InProgress',
  PENDING_APPROVAL: 'PendingApproval',
  PENDING_REJECTION: 'PendingRejection',
} as const
export type TClientDocumentStatusKey = keyof typeof CLIENT_DOCUMENT_STATUS
export type TClientDocumentStatusType = (typeof CLIENT_DOCUMENT_STATUS)[TClientDocumentStatusKey]

// Note: These constants are used for both document and file statuses
// For document status: PendingApproval/PendingRejection display as InProgress on client side
// For file status: PendingApproval/PendingRejection display as WaitingApproval on client side

export const INVOICE_STATUS = {
  PAID: 'Paid',
  NOT_PAY_YET: 'NotPayYet',
} as const
export type TInvoiceStatusKey = keyof typeof INVOICE_STATUS
export type TInvoiceStatusType = (typeof INVOICE_STATUS)[TInvoiceStatusKey]

export const USER_ROLE = {
  FINGERPRINT_STAFF: 'FingerprintStaff',
  CLIENT: 'Client',
  ADMIN: 'Admin',
} as const
export type TUserRoleKey = keyof typeof USER_ROLE
export type TUserRoleType = (typeof USER_ROLE)[TUserRoleKey]

/** Roles that can access fingerprinting staff area (FingerprintStaff or Admin) */
export const FINGERPRINTING_STAFF_ROLES: readonly string[] = [
  USER_ROLE.FINGERPRINT_STAFF,
  USER_ROLE.ADMIN,
] as const

export function isFingerprintingStaff(roles: string[] | undefined): boolean {
  if (!roles?.length) return false
  return FINGERPRINTING_STAFF_ROLES.some((r) => roles.includes(r))
}
